import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnAS: CultureInfo = {
  name: 'en-AS',
  displayName: 'English (American Samoa)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-AS',
  parent: CultureInfoEn
};
